// https://en.uesp.net/wiki/Online:Styles

export const styles = [
  { name: 'crafting.mofit.1.altmer', stone: 'crafting.stone.1.altmer' },
  { name: 'crafting.mofit.2.dunmer', stone: 'crafting.stone.2.dunmer' },
  { name: 'crafting.mofit.3.bosmer', stone: 'crafting.stone.3.bosmer' },
  { name: 'crafting.mofit.4.nord', stone: 'crafting.stone.4.nord' },
  { name: 'crafting.mofit.5.breton', stone: 'crafting.stone.5.breton' },
  { name: 'crafting.mofit.6.redguard', stone: 'crafting.stone.6.redguard' },
  { name: 'crafting.mofit.7.khajiit', stone: 'crafting.stone.7.khajiit' },
  { name: 'crafting.mofit.8.orcish', stone: 'crafting.stone.8.orcish' },
  { name: 'crafting.mofit.9.argonian', stone: 'crafting.stone.9.argonian' },
  { name: 'crafting.mofit.10.imperial', stone: 'crafting.stone.10.imperial' },
  { name: 'crafting.mofit.11.ancientElf', stone: 'crafting.stone.11.ancientElf' },
  { name: 'crafting.mofit.12.barbaric', stone: 'crafting.stone.12.barbaric' },
  { name: 'crafting.mofit.13.primal', stone: 'crafting.stone.13.primal' },
  { name: 'crafting.mofit.14.daedric', stone: 'crafting.stone.14.daedric' },
  { name: 'crafting.mofit.15.dwemer', stone: 'crafting.stone.15.dwemer' },
  { name: 'crafting.mofit.16.glass', stone: 'crafting.stone.16.glass' },
  { name: 'crafting.mofit.17.xivkyn', stone: 'crafting.stone.17.xivkyn' },
  { name: 'crafting.mofit.18.akaviri', stone: 'crafting.stone.18.akaviri' },
  { name: 'crafting.mofit.19.mercenary', stone: 'crafting.stone.19.mercenary' },
  { name: 'crafting.mofit.20.yokudan', stone: 'crafting.stone.20.yokudan' },
  { name: 'crafting.mofit.21.ancientOrc', stone: 'crafting.stone.21.ancientOrc' },
  { name: 'crafting.mofit.22.trinimac', stone: 'crafting.stone.22.trinimac' },
  { name: 'crafting.mofit.23.malacath', stone: 'crafting.stone.23.malacath' },
  { name: 'crafting.mofit.24.outlaw', stone: 'crafting.stone.24.outlaw' },
  { name: 'crafting.mofit.25.aldmeriDominion', stone: 'crafting.stone.25.aldmeriDominion' },
  { name: 'crafting.mofit.26.daggerfallCovenant', stone: 'crafting.stone.26.daggerfallCovenant' },
  { name: 'crafting.mofit.27.ebonheartPact', stone: 'crafting.stone.27.ebonheartPact' },
  { name: 'crafting.mofit.28.raGada', stone: 'crafting.stone.28.raGada' },
  { name: 'crafting.mofit.29.soulShriven', stone: 'crafting.stone.29.soulShriven' },
  { name: 'crafting.mofit.30.moragTong', stone: 'crafting.stone.30.moragTong' },
  { name: 'crafting.mofit.31.skinchanger', stone: 'crafting.stone.31.skinchanger' },
  { name: 'crafting.mofit.32.abahsWatch', stone: 'crafting.stone.32.abahsWatch' },
  { name: 'crafting.mofit.33.thievesGuild', stone: 'crafting.stone.33.thievesGuild' },
  { name: 'crafting.mofit.34.assassinsLeague', stone: 'crafting.stone.34.assassinsLeague' },
  { name: 'crafting.mofit.35.dromAthra', stone: 'crafting.stone.35.dromAthra' },
  { name: 'crafting.mofit.36.darkBrotherhood', stone: 'crafting.stone.36.darkBrotherhood' },
  { name: 'crafting.mofit.37.ebony', stone: 'crafting.stone.37.ebony' },
  { name: 'crafting.mofit.38.draugr', stone: 'crafting.stone.38.draugr' },
  { name: 'crafting.mofit.39.minotaur', stone: 'crafting.stone.39.minotaur' },
  { name: 'crafting.mofit.40.orderOfTheHour', stone: 'crafting.stone.40.orderOfTheHour' },
  { name: 'crafting.mofit.41.celestial', stone: 'crafting.stone.41.celestial' },
  { name: 'crafting.mofit.42.hollowjack', stone: 'crafting.stone.42.hollowjack' },
  { name: 'crafting.mofit.43.grimHarlequin', stone: 'crafting.stone.43.grimHarlequin' },
  { name: 'crafting.mofit.44.silkenRing', stone: 'crafting.stone.44.silkenRing' },
  { name: 'crafting.mofit.45.mazzatun', stone: 'crafting.stone.45.mazzatun' },
  { name: 'crafting.mofit.46.stalhrimFrostcaster', stone: 'crafting.stone.46.stalhrimFrostcaster' },
  { name: 'crafting.mofit.47.buoyantArmiger', stone: 'crafting.stone.47.buoyantArmiger' },
  { name: 'crafting.mofit.48.ashlander', stone: 'crafting.stone.48.ashlander' },
  { name: 'crafting.mofit.49.militantOrdonnateur', stone: 'crafting.stone.49.militantOrdonnateur' },
  { name: 'crafting.mofit.50.telvanni', stone: 'crafting.stone.50.telvanni' },
  { name: 'crafting.mofit.51.hlaalu', stone: 'crafting.stone.51.hlaalu' },
  { name: 'crafting.mofit.52.redoran', stone: 'crafting.stone.52.redoran' },
  { name: 'crafting.mofit.53.tsaesci', stone: 'crafting.stone.53.tsaesci' },
  { name: 'crafting.mofit.54.bloodforge', stone: 'crafting.stone.54.bloodforge' },
  { name: 'crafting.mofit.55.dreadhorn', stone: 'crafting.stone.55.dreadhorn' },
  { name: 'crafting.mofit.56.apostle', stone: 'crafting.stone.56.apostle' },
  { name: 'crafting.mofit.57.ebonshadow', stone: 'crafting.stone.57.ebonshadow' },
  { name: 'crafting.mofit.58.fangLair', stone: 'crafting.stone.58.fangLair' },
  { name: 'crafting.mofit.59.scalecaller', stone: 'crafting.stone.59.scalecaller' },
  { name: 'crafting.mofit.60.wormCult', stone: 'crafting.stone.60.wormCult' },
  { name: 'crafting.mofit.61.psijic', stone: 'crafting.stone.61.psijic' },
  { name: 'crafting.mofit.62.sapiarch', stone: 'crafting.stone.62.sapiarch' },
  { name: 'crafting.mofit.63.dremora', stone: 'crafting.stone.63.dremora' },
  { name: 'crafting.mofit.64.pyandonean', stone: 'crafting.stone.64.pyandonean' },
  { name: 'crafting.mofit.65.huntsman', stone: 'crafting.stone.65.huntsman' },
  { name: 'crafting.mofit.66.silverDawn', stone: 'crafting.stone.66.silverDawn' },
  { name: 'crafting.mofit.67.welkynar', stone: 'crafting.stone.67.welkynar' },
  { name: 'crafting.mofit.68.honorGuard', stone: 'crafting.stone.68.honorGuard' },
  { name: 'crafting.mofit.69.deadWater', stone: 'crafting.stone.69.deadWater' },
  { name: 'crafting.mofit.70.elderArgonian', stone: 'crafting.stone.70.elderArgonian' },
  { name: 'crafting.mofit.71.coldsnapGoblin', stone: 'crafting.stone.71.coldsnapGoblin' },
  { name: 'crafting.mofit.72.meridian', stone: 'crafting.stone.72.meridian' },
  { name: 'crafting.mofit.73.anequina', stone: 'crafting.stone.73.anequina' },
  { name: 'crafting.mofit.74.pellitine', stone: 'crafting.stone.74.pellitine' },
  { name: 'crafting.mofit.75.sunspire', stone: 'crafting.stone.75.sunspire' },
  { name: 'crafting.mofit.76.dragonguard', stone: 'crafting.stone.76.dragonguard' },
  { name: 'crafting.mofit.77.stagesOfZen', stone: 'crafting.stone.77.stagesOfZen' },
  { name: 'crafting.mofit.78.moongraveFane', stone: 'crafting.stone.78.moongraveFane' },
  { name: 'crafting.mofit.79.refabricated', stone: 'crafting.stone.79.refabricated' },
  { name: 'crafting.mofit.80.shieldOfSenchal', stone: 'crafting.stone.80.shieldOfSenchal' },
  { name: 'crafting.mofit.81.newMoonPriest', stone: 'crafting.stone.81.newMoonPriest' },
  { name: 'crafting.mofit.82.icereachCoven', stone: 'crafting.stone.82.icereachCoven' },
  { name: 'crafting.mofit.83.pyreWatch', stone: 'crafting.stone.83.pyreWatch' },
  { name: 'crafting.mofit.84.blackreachVanguard', stone: 'crafting.stone.84.blackreachVanguard' },
  { name: 'crafting.mofit.85.greymoor', stone: 'crafting.stone.85.greymoor' },
  { name: 'crafting.mofit.86.seaGiant', stone: 'crafting.stone.86.seaGiant' },
  { name: 'crafting.mofit.87.ancestralNord', stone: 'crafting.stone.87.ancestralNord' },
  { name: 'crafting.mofit.88.ancestralOrc', stone: 'crafting.stone.88.ancestralOrc' },
  { name: 'crafting.mofit.89.ancestralHighElf', stone: 'crafting.stone.89.ancestralHighElf' },
  { name: 'crafting.mofit.90.thornLegion', stone: 'crafting.stone.90.thornLegion' },
  { name: 'crafting.mofit.91.hazardousAlchemy', stone: 'crafting.stone.91.hazardousAlchemy' },
  { name: 'crafting.mofit.94.ancestralReach', stone: 'crafting.stone.94.ancestralReach' },
  // { name: "crafting.mofit.96.arkthzandArmory", stone: "crafting.stone.96.arkthzandArmory" },
];

export const rawMotifs = [
  {
    value: 'style.none', stone: 'stone.any', label: 'style.none', color: '#fcb935', isFixed: true,
  },
].concat(
  styles.map((style) => ({
    value: style.name, stone: style.stone, label: style.name, color: '#2DC50E', isFixed: true,
  })),
);

const sortedMotifs = (intl) => [
  {
    value: 'style.none', stone: 'stone.any', label: 'style.none', color: '#fcb935', isFixed: true,
  },
].concat(
  styles.sort((a, b) => ((intl.formatMessage({ id: a.name }) > intl.formatMessage({ id: b.name })) ? 1 : -1))
    .map((style) => ({
      value: style.name, stone: style.stone, label: style.name, color: '#2DC50E', isFixed: true,
    })),
);

export default sortedMotifs;
